import { render, staticRenderFns } from "./paid.vue?vue&type=template&id=fabfca4e&scoped=true"
import script from "./paid.vue?vue&type=script&lang=js"
export * from "./paid.vue?vue&type=script&lang=js"
import style0 from "./paid.vue?vue&type=style&index=0&id=fabfca4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabfca4e",
  null
  
)

export default component.exports